import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import {
  LazyLoadImage,
  trackWindowScroll,
} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const ClientsSection = ({ scrollPosition }) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const sectionElement = document.getElementById('clients');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => setIsInView(entry.isIntersecting));
      },
      { threshold: 0.1 },
    );

    if (sectionElement) observer.observe(sectionElement);

    return () => {
      if (sectionElement) observer.unobserve(sectionElement);
    };
  }, []);

  const sectionStyle = {
    transition: 'opacity 0.5s ease, transform 0.5s ease',
    opacity: isInView ? 1 : 0,
    transform: isInView ? 'translateY(0)' : 'translateY(20px)',
    visibility: isInView ? 'visible' : 'hidden',
  };
  return (
    <section
      id="clients"
      className="clients section light-background"
      style={sectionStyle}
    >
      <div className="container">
        <Swiper
          modules={[Autoplay, Pagination]}
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 40 },
            480: { slidesPerView: 3, spaceBetween: 60 },
            640: { slidesPerView: 4, spaceBetween: 80 },
            992: { slidesPerView: 5, spaceBetween: 100 },
          }}
        >
          {[
            { src: '/img/clients/BPJS.webp', alt: 'BPJS' },
            {
              src: '/img/clients/BPJSKETENAGAKERJAAN.webp',
              alt: 'BPJS KETENAGAKERJAAN',
            },
            { src: '/img/clients/KEMKES.webp', alt: 'KEMKES' },
            { src: '/img/clients/BERAKHLAK.webp', alt: 'BERAKHLAK' },
            { src: '/img/clients/JAMBISMARTCITY.webp', alt: 'JAMBISMARTCITY' },
          ].map((client, index) => (
            <SwiperSlide key={index}>
              <LazyLoadImage
                src={client.src}
                alt={client.alt}
                className="img-fluid"
                effect="blur"
                width="200"
                height="100"
                srcSet={`${client.src} 1x, ${client.src} 2x`}
                sizes="(max-width: 768px) 100vw, 200px"
                scrollPosition={scrollPosition}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-pagination"></div>
      </div>
    </section>
  );
};

export default trackWindowScroll(ClientsSection);
